<template>
 <div>
  <sdPageHeader title="Selecteer een flow"></sdPageHeader>
  <Main>
   <a-row :gutter="30">
    <template v-if="!loadingFlows && flows.length > 0">
     <a-col v-for="item in flows" :key="item.id" :sm="8" :xs="24">
      <Suspense>
       <template #default>
        <FlowCards :data="item" @set-flow="handleSelectFlow($event)"/>
       </template>
       <template #fallback>
        <sdCards headless>
         <a-skeleton :paragraph="{ rows: 22 }" active/>
        </sdCards>
       </template>
      </Suspense>
     </a-col>
    </template>
    <a-col v-if="loadingFlows" :md="24">
     <div class="spin" style="height:200px">
      <a-spin/>
     </div>
    </a-col>
   </a-row>
   <a-row v-if="!loadingFlows && flows.length < 1" class="w-100">
    <a-col :xs="24">
     <sdAlerts
      :closable="false"
      :outlined="false"
      :showIcon="true"
      description="Er zijn geen flows voor jou beschikbaar."
      message=""
      type="warning"
     />
    </a-col>
   </a-row>
  </Main>
 </div>
</template>

<script>
import {computed, defineComponent, onMounted} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import FlowCards from "./component/FlowCards";
import {Main} from "../styled";

export default defineComponent({
 name: "OrderFlow",
 components: {
  FlowCards,
  Main,
 },
 setup() {
  const router = useRouter()
  const {state, dispatch} = useStore();
  const flows = computed(() => state.flows.flows);

  const loadingFlows = computed(() => state.flows.loadingFlows);
  const handleSelectFlow = async (data) => {
   try {
    console.log('handleSelectFlow called with data:', data);
    console.log('data.config:', data.config);
    console.log('data.config.type:', data.config.type);
    console.log('data.config.subType:', data.config.subType);
    console.log('data.config.productID:', data.config.productID);
    
    if (!data || !data.config) {
     console.error('Invalid data structure:', data);
     return;
    }
    
    switch (data.config.type) {
    case 'ROI':
     await dispatch('setOrderFlow', data);
     await router.push(`/order/roi/create/${data.config.productID}`);
     break;
    case 'SUSTAINABILITYCONSULTATION':
     await dispatch('setOrderFlow', data);
     await router.push(`/order/sustainability-consultation/create/${data.config.productID}`);
     break;
    case 'LETTEROFCONTENT':
     await dispatch('setOrderFlow', data);
     await router.push(`/order/letter-of-content/create/${data.config.productID}`);
     break;
    case 'ENERGY':
     await dispatch('setOrderFlow', data);
     await router.push('/order/energy/create');
     break;
    case 'SOLAR':
     await dispatch('setOrderFlowSolar', data);
     await router.push('/order/solar/create');
     break;
    case 'SVM':
     await dispatch('setOrderFlowSVM', data);
     await router.push('/order/svm/create');
     break;
    case 'LEAD':
     await dispatch('setOrderFlowLead', data);
     await router.push(`/order/lead/create/${data.config.productID}`);
     break;
    case 'SUSTAINABILITYWITHPRODUCT':
     console.log('SUSTAINABILITYWITHPRODUCT case entered (as type)');
     await dispatch('setOrderFlowShop', data);
     await router.push(`/order/battery/sustainability-with-product/create/${data.config.productID}?type=${data.config.subType || data.config.type}`);
     break;
    case 'SHOP':
     console.log('SHOP case entered, subType:', data.config.subType);
     if (data.config.subType === 'BATTERYADVANCEDROI') {
      console.log('Routing to BATTERYADVANCEDROI');
      await dispatch('setOrderFlowShop', data);
      await router.push(`/order/battery-roi/mkb/create/${data.config.productID}?type=${data.config.subType}`);
      break;
     } else if (data.config.subType === 'SUSTAINABILITYADVANCED') {
      console.log('Routing to SUSTAINABILITYADVANCED');
      await dispatch('setOrderFlowShop', data);
      await router.push(`/order/battery/sustainability-advanced/create/${data.config.productID}?type=${data.config.subType}`);
      break;
     } else if (data.config.subType === 'SUSTAINABILITYWITHPRODUCT') {
      console.log('Routing to SUSTAINABILITYWITHPRODUCT');
      await dispatch('setOrderFlowShop', data);
      await router.push(`/order/battery/sustainability-with-product/create/${data.config.productID}?type=${data.config.subType}`);
      break;
     } else if (data.config.subType === 'BATTERYADVANCED' && (data.config.productID === 11 || data.config.productID === 17 || data.config.productID === 18)) {
      await dispatch('setOrderFlowShop', data);
      await router.push(`/order/battery/soho/create/${data.config.productID}?type=${data.config.subType}`);
      break;
     } else if (data.config.subType === 'BATTERYADVANCED' && (data.config.productID === 5 || data.config.productID === 12)) {
      // Check if tenant is 27 or 28 - if so, use regular battery flow instead of MKB
      const tenant = localStorage.getItem('tenant');
      const tenantId = tenant ? JSON.parse(tenant) : null;

      if (tenantId === 27 || tenantId === 28) {
       // Use regular battery flow for tenants 27 and 28
       await dispatch('setOrderFlowShop', data);
       await router.push(`/order/battery/create/${data.config.productID}?type=${data.config.subType}`);
       break;
      } else {
       await dispatch('setOrderFlowShop', data);
       await dispatch('setTariffMKBs');
       await router.push(`/order/battery/mkb/create/${data.config.productID}?type=${data.config.subType}`);
       break;
      }
     } else if (data.config.subType === 'BATTERYADVANCED' && data.config.productID !== 5 && data.config.productID !== 11 && data.config.productID !== 12 && data.config.productID !== 17 && data.config.productID !== 18) {
      await dispatch('setOrderFlowShop', data);
      await router.push(`/order/battery/create/${data.config.productID}?type=${data.config.subType}`);
      break;
     }

     if (data.config.subType === 'WHOLESALE') {
      await dispatch('setOrderFlowShop', data);
      await router.push(`/order/shop/wholesale/create/${data.config.productID}?type=${data.config.subType}`);
      break;
     }
     await dispatch('setOrderFlowShop', data);
     await router.push(`/order/shop/create/${data.config.productID}?type=${data.config.subType}`);
     break;
    case 'SOLARSIMPLE':
     await dispatch('setOrderFlowSolarSimple', data);
     await router.push('/order/solar-simple/create');
     break;
    case 'HYDROMX':
     await dispatch('setOrderFlowSolar', data);
     await router.push('/order/hydromx/create');
     break;
    default:
     console.warn('No matching case for type:', data.config.type);
     break;
   }
   } catch (error) {
    console.error('Error in handleSelectFlow:', error);
   }
  };

  onMounted(async () => {
   await dispatch('cleanFlows');
   await dispatch("cleanGlobalSearch");
   await dispatch('resetCreateOrderConnections');
   await dispatch('resetCreateOrder');
   await dispatch('resetSVMOrder');
   await dispatch('getFlows');
   await dispatch('resetShopOrder');
  });

  return {
   flows,
   handleSelectFlow,
   loadingFlows,
  }
 }
});
</script>

<style scoped>

</style>
